import React from "react";
import { Toaster } from "react-hot-toast";

const HotToast: React.FC = () => (
  <Toaster position="top-right" reverseOrder={false} />
);

export default HotToast;
